import React, { Fragment, useState, useEffect } from "react";
import EditProject from "../../Common/Component/EditProject";
import fetchWrapper from "../../Common/api/fetchWrapper";
import { API_URL } from "../../Common/Config/Config";
import { handleGetData, FormData } from '../../Common/api/helper';
import { useParams } from "react-router";

const AsoAdminEditProject = () => {
    const [data, setData] = useState()
    const [notesData, setNotesData] = useState()
    const id = useParams()?.id;
    
    
    const loadData = async (id) => {
        const options = {
          method: 'GET'
        }
        await fetchWrapper(`${API_URL}/projects/${id}`, options)
          .then((res) => {
            const data = res.json;
            data.start_date = data.start_date ? new Date(data.start_date) : null
            data.end_date = data.end_date ? new Date(data.end_date) : null
            setData(data)
            })
          .catch((err) => console.log(err));
    }

    
    useEffect(()=> {
        loadData(id)
    }, [])

    return (
        <Fragment>
            <EditProject preData={data} />
        </Fragment>
    )
}

export default AsoAdminEditProject;